import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbDropdownModule, NgbNavModule, NgbProgressbarModule, NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from './loader/loader.component';
import { ModalLoaderComponent } from './modal-loader/modal-loader.component';
import { FilteredProductsComponent } from '../fitting-selector/filtered-products/filtered-products.component';
import { DesignPressuresComponent } from '../fitting-selector/design-pressures/design-pressures.component';
import { ImgFromBytesPipe } from '../pig-selector/img-from-bytes.pipe';
import { SpecificationsComponent as FittingSpecificationsComponent, SpecificationsComponent } from '../fitting-selector/specifications/specifications.component';
import { ToGroupsPipe } from '../fitting-selector/to-groups.pipe';
import { ProductConfigurationsComponent } from '../fitting-selector/product-configurations/product-configurations.component';
import { CommonIncompatibleProductsComponent } from '../fitting-selector/common-incompatible-products/common-incompatible-products.component';
import { AssociatedProductsComponent } from '../fitting-selector/associated-products/associated-products.component';
import { AssociatedProductConfigurationsModalComponent } from '../fitting-selector/associated-product-configurations-modal/associated-product-configurations-modal.component';
import { RouterModule } from '@angular/router';
import { ClosureSpecificationsComponent } from '../closure-selector/closure-specifications/closure-specifications.component';
import { SealMaterialsComponent } from '../closure-selector/seal-materials/seal-materials.component';
import { ORingOptionsComponent } from '../closure-selector/oring-options/oring-options.component';
import { FilterResultItemComponent } from '../pig-selector/filter-result-item/filter-result-item.component';
import { PigDetailModalComponent } from '../pig-selector/pig-detail-modal/pig-detail-modal.component';
import { ToastsComponent } from './toasts/toasts.component';
import { IsInGroupPipe } from './is-in-group.pipe';
import { ManagementComponent } from './management/management.component';
import { TruncatePipe } from './truncate.pipe';
import { ConfigurationFilterFormValuesPipe } from '../fitting-selector/configuration-filter-form-values.pipe';
import { ShowFittingFilterPipe } from '../fitting-selector/show-fitting-filter.pipe';
import { PaginatorModule } from '@tdw/paginator';
import { InputSelectComponent } from './input-select/input-select.component';
import { InputTextComponent } from './input-text/input-text.component';
import { InputTextAreaComponent } from './input-text-area/input-text-area.component';
import { InputBooleanComponent } from './input-boolean/input-boolean.component';
import { ToValidFlatterFilesKeysPipe } from '../fitting-selector/to-valid-flatter-files-keys.pipe';
import { TableFilterComponent } from '../admin/table-filter/table-filter.component';
import { TableFilterSelectComponent } from '../admin/table-filter-select/table-filter-select.component';
import { ReplacesPartsComponent } from './replaces-parts/replaces-parts.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ValidationMessagePipe } from './validation-message.pipe';
import { UrlBypassPipe } from './url-bypass.pipe';
import { ExportExcelComponent } from './export-excel/export-excel.component';
import { FractionPipe } from './fraction.pipe';
import { DndDirective } from './dnd.directive';
import { DropzoneComponent } from './dropzone/dropzone.component';
import { ORingDetailComponent } from '../oring-selector/oring-detail/oring-detail.component';
import { ORingTempRangePipe } from '../oring-selector/oring-temp-range.pipe';
import { ClosureSpecificationsModalComponent } from '../closure-selector/closure-specifications-modal/closure-specifications-modal.component';

const MODULES = [
  HttpClientModule,
  ReactiveFormsModule,
  FormsModule,
  NgbTooltipModule,
  NgbAccordionModule,
  RouterModule,
  NgbToastModule,
  NgbNavModule,
  PaginatorModule,
  NgbDropdownModule,
  NgbProgressbarModule
];

const COMPONENTS = [
  LoaderComponent,
  ModalLoaderComponent,
  FilteredProductsComponent,
  DesignPressuresComponent,
  ImgFromBytesPipe,
  FittingSpecificationsComponent,
  ToGroupsPipe,
  ProductConfigurationsComponent,
  CommonIncompatibleProductsComponent,
  AssociatedProductsComponent,
  AssociatedProductConfigurationsModalComponent,
  ClosureSpecificationsComponent,
  ClosureSpecificationsModalComponent,
  SpecificationsComponent,
  SealMaterialsComponent,
  ORingOptionsComponent,
  ORingDetailComponent,
  ORingTempRangePipe,
  FilterResultItemComponent,
  PigDetailModalComponent,
  ToastsComponent,
  IsInGroupPipe,
  InputSelectComponent,
  InputTextComponent,
  InputTextAreaComponent,
  InputBooleanComponent,
  ToValidFlatterFilesKeysPipe,
  TableFilterComponent,
  TableFilterSelectComponent,
  ValidationMessagePipe,
  ExportExcelComponent,
  UrlBypassPipe,
  FractionPipe,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ManagementComponent,
    TruncatePipe,
    ConfigurationFilterFormValuesPipe,
    ShowFittingFilterPipe,
    ReplacesPartsComponent,
    ConfirmModalComponent,
    DndDirective,
    DropzoneComponent
  ],
  imports: [
    CommonModule,
    [...MODULES],
  ],
  exports: [
    [...MODULES],
    [...COMPONENTS],
    TruncatePipe,
    DropzoneComponent,
    DndDirective
  ]
})
export class SharedModule { }
